import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCvData } from '../context/CvDataContext.js';
import './SkillModal.css';

const SkillModal = ({ isOpen, onClose, technology, onCompanyClick }) => {
  const { findCompaniesByTechnology, experience } = useCvData();
  if (!isOpen || !technology) return null;

  const companies = findCompaniesByTechnology(technology);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="skill-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
        >
          <motion.div
            className="skill-modal-content"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3, type: "spring", damping: 25 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="skill-modal-header">
              <h2>Companies where I used {technology}</h2>
              <motion.button
                className="skill-modal-close"
                onClick={onClose}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                ×
              </motion.button>
            </div>

            <div className="skill-modal-body">
              {companies.length > 0 ? (
                <div className="companies-list">
                  {companies.map((company, index) => {
                    const fullExperience = experience.find(exp => exp.id === company.id);
                    
                    return (
                      <motion.div
                        key={company.id}
                        className="company-item clickable"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                        whileHover={{ scale: 1.02 }}
                        onClick={() => onCompanyClick && onCompanyClick(fullExperience)}
                        title={`Click to view full experience details for ${company.company}`}
                      >
                      <div className="company-logo">
                        <img 
                          src={company.logo} 
                          alt={`${company.company} logo`}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                        <div className="company-logo-fallback" style={{ display: 'none' }}>
                          {company.company.charAt(0)}
                        </div>
                      </div>
                      
                      <div className="company-info">
                        <h3 className="company-name">{company.company}</h3>
                        <p className="company-position">{company.position}</p>
                        <p className="company-period">{company.period}</p>
                        
                        <div className="company-technologies">
                          {company.technologies.map((tech, techIndex) => (
                            <span 
                              key={techIndex}
                              className={`tech-tag ${tech.toLowerCase() === technology.toLowerCase() ? 'highlighted' : ''}`}
                            >
                              {tech}
                            </span>
                          ))}
                        </div>
                      </div>
                    </motion.div>
                    );
                  })}
                </div>
              ) : (
                <div className="no-companies">
                  <p>No companies found where I used {technology}</p>
                </div>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SkillModal;
